import React from 'react';
import moment from 'moment';
import Input from '../ui/Input';

const DateFieldMobile = ({ parentDate, onDateChange }) => (
  <div
    className="w-full flex items-center relative date"
  >
    <Input
      type="date"
      className="flex-1 block w-auto py-2 form-control z-10"
      style={{ height: '40px' }}
      onChange={(e) => {
        onDateChange(e.target.value && moment(e.target.value));
      }}
    />
  </div>
);

export default DateFieldMobile;
